import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  control: (styles) => ({ ...styles, height: "100%" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? "#536493" : "#536493",
    };
  },
  indicatorsContainer: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#536493",
    borderRadius: "4px",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#ffffff",
    fontWeight: 600,
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#ffffff",
    ":hover": {
      backgroundColor: "#3d4a6e",
      color: "#ffffff",
    },
  }),
};

export const multiSelectStyles: StylesConfig = {
  ...selectStyles,
  control: (styles) => ({ ...styles, minHeight: "100%", height: "auto" }),
};

export const toastStyles = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
